export const getIHaveWatchedPercentForEpgItem = (epgItem) =>
  epgItem.follow
    && epgItem.duration
    && (epgItem.follow / epgItem.duration) * 100
  || undefined;
